import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {GroupByPipe} from "ngx-pipes";

/**
 * Generated class for the CommentListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'comment-list',
  templateUrl: 'comment-list.html',
  providers: [GroupByPipe]
})
export class CommentListComponent implements OnChanges{

  @Input('list') list: Array<any>;
  @Output('click') click: EventEmitter<any> = new EventEmitter();

  public groupedList: Array<any> = [];

  constructor(private groupedByPipe: GroupByPipe) {
    console.log('Hello CommentListComponent Component');
  }

  ngOnChanges(changes: SimpleChanges){

    if(changes['list']){
      this.groupedList = [];
      let _grouped = this.groupedByPipe.transform(this.list, 'category');
      for(let categoryName in _grouped){
        this.groupedList.push({categoryName: categoryName, templates: _grouped[categoryName]});
      }
    }
  }

  public edit(selected: any): void {
    this.click.emit(selected);
  }


}



// WEBPACK FOOTER //
// ./src/components/comment-list/comment-list.ts